'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoWifi = function IoWifi(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm17.5 7.5c6.3 0 12.2 2.3 16.7 6.6l0.8 0.7-0.8 0.7-3.3 3.3-0.7-0.7c-3.4-3.2-8-5-12.7-5s-9.3 1.8-12.7 5l-0.7 0.7-3.3-3.3-0.8-0.7 0.8-0.7c4.5-4.3 10.5-6.6 16.7-6.6z m11 12.5l0.9 0.8-0.8 0.8-2.6 2.5-0.7 0.7-0.8-0.7c-1.9-1.7-4.4-2.7-7-2.7s-5.1 1-7 2.7l-0.8 0.7-0.7-0.7-2.6-2.5-0.8-0.8 0.9-0.8c2.9-2.6 6.5-4.1 10.3-4.2h0.7c4.1 0 8 1.5 11 4.2z m-11 12.5l-4.8-4.8-0.9-0.8 0.9-0.8c1.4-0.9 2.5-1.6 4.8-1.6s3.7 0.7 4.8 1.6l0.9 0.8-0.8 0.8-4.1 4z' })
        )
    );
};

exports.default = IoWifi;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/wifi.js
// module id = 2763
// module chunks = 0